import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./Steps.css";
import { useLocation, useNavigate } from "react-router-dom";
import Card from '@mui/material/Card';
import { Button } from '@mui/material';
import { useForwardChevron } from '../../../i18n/DirectionalIcons';
import { useT } from "../../../i18n";


function Step2(props) {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const t = useT();
  const FwdChevron = useForwardChevron();
  const { user } = useSelector((state) => state.auth)

  // A8: pre-select the department already chosen (so going back from a later step shows it selected)
  const [selected, setSelected] = useState(props.formData.department_id || null)

  // pick the department (highlight as "נבחר") — do NOT advance yet
  const Click = (id) => {
    setSelected(id);
  }

  // confirm the chosen department and move on
  const Confirm = () => {
    if (!selected) return;
    props.setFormData({ ...props.formData, department_id: selected });
    props.next();
  }

  return (
    <div className="step step2">
        <h5>{t("step2.title")}</h5>
        {user?.departments?.map(d => (
            <Card
              onClick={() => Click(d.id)}
              key={d.id}
              className={selected === d.id ? 'service-selected' : ''}
            >
              {selected === d.id && <span className="selected-badge">✓</span>}
              {d.title}
            </Card>
        ))}

        <Button
          variant="contained"
          disabled={!selected}
          className="next-btn"
          onClick={Confirm}
          sx={{ borderRadius: 0, fontSize: 18 }}
          endIcon={<FwdChevron />}
        >
          {t("common.next")}
        </Button>
    </div>
  );
}

export default Step2;
